module.exports = __webpack_public_path__ + "static/media/19ESCAP23.9c2bd32e.jpg";